<template>
    <div class="d-flex">
        <v-select
            dense
            outlined
            hide-details
            background-color="white"
            clearable
            :items="items"
            :placeholder="$t('icon')"
            item-value="icon"
            item-text="icon"
            return-object
            v-bind="$attrs"
            :value="value"
            @input="$emit('input', $event ? $event.icon : null)"
        >
            <template #item="{ item }">
                <div class="d-flex align-center">
                    <img
                        :src="item.defaultIconUrl"
                        class="ma-1 pa-1"
                        width="48"
                        :style="{ backgroundColor: iconBackground(item) }"
                    />
                    <span>{{ item.icon }}</span>
                </div>
            </template>
        </v-select>
        <img
            v-if="iconUrl"
            :src="iconUrl"
            class="ml-1 pa-1"
            width="32"
            :style="{ backgroundColor: iconBackground(selectedIcon) }"
        />
    </div>
</template>

<script>
import { globalParam } from '@/helpers/globals';

/**
 * Icon-Select for banners
 */
export default {
    name: 'BannerIconSelect',
    props: {
        value: { type: String, default: null },
    },
    computed: {
        iconUrl() {
            let icon = this.selectedIcon;
            if (icon) {
                return icon.defaultIconUrl;
            }
            return null;
        },
        selectedIcon() {
            return this.items.find((item) => this.value === item.icon);
        },
    },
    created() {
        this.items = globalParam('banner_icons') || [];
    },
    methods: {
        iconBackground(item) {
            if (item.iconBackgroundColor) {
                return item.iconBackgroundColor;
            }
            return 'var(--agenda-color)';
        },
    }
};
</script>
